<style>
.con-vs-avatar {
  background: transparent !important;
  width: 40px;
  height: 40px;
}
.vs-avatar--con-img {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs-avatar--con-img img {
  height: auto !important;
  width: 45% !important;
}
.cursor-move .vs-list--item .vs-list--avatar{height: 26px; width:37px}

svg.feather.feather-upload {
    height: 16px;
    width: 16px;
}
label.type-evnt-lbl {
  width: 110px;
  margin-right: 10px;
}


.type-evnt {
  width: 250px !important;
  margin-top: 0;
}

</style>
<template>
  <div class="manage-menu-wrap-hld">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
      layout="vertical"
      @on-complete="formSubmitted"
    >
      <div class="header-custome">
        <div class="wrap-head">
          <h2>Manage Menu</h2>
          <p>Drag available menus from left and drop to right for navigation menu.</p>
        </div>
        <!--<div class="knowlg-base-wrap-sec">
          <a href="/pages/knowledge-base/category-eventdashboard/question-4">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-help-circle"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </span> Need help with this section?
          </a>
        </div>-->
      </div>
      <!-- tab 2 content -->
      <tab-content title="Web Menu" class="mb-5" icon="feather icon-globe">
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full NotificationShow">
            <div class="type-evnt">
              <label>Show Web Notification</label>
              <vs-switch v-model="ShowNotification" name="ShowNotification">
                <span slot="true">True</span>
                <span slot="false">False</span>
              </vs-switch>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <input type="file" class="hidden" ref="changeIcon" @change="UpdateIcon" accept="image/*" />
          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="vx-col sm:w-1/1 w-full mb-1">
                <div class="menu-head">
                  <vs-list-header title="Available Menus" color="primary"></vs-list-header>
                  <span class="allmenu-topicons">
                    <vs-switch color="dark" v-model="theme" @change="fetchThemeIcon">
                      <span slot="off">LIGHT</span>
                      <span slot="on">DARK</span>
                    </vs-switch>
                  </span>
                </div>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="AvailableMenu"
                :move="checkMoveSelected"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_de" />
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                  :list="AvailableMenu"
                  :move="checkMoveSelected"
                  :group="{name:'tags',pull: 'clone', put: false }"
                  :clone="cloneOriginal"
                  class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_zh" />
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="AvailableMenu"
                :move="checkMoveSelected"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_fr" />
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="AvailableMenu"
                :move="checkMoveSelected"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel" />
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="Top Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Add Custom Menu" position="top">
                  <vs-button radius size="small" color="dark" type="border" icon="add" @click="addCustomPageMenu('top')"></vs-button>
                </vx-tooltip>                
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete" @click="removeAll('top')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="SelectedMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_de"
                    @click="hideTextBox(listItem.MenuID,'top')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_de"
                        :class="`top_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'top')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <!-- <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('top',listItem.MenuID)"
                      />
                    </span> -->
                    <span class="menu-delete" @click="removeSelected(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="SelectedMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_zh"
                    @click="hideTextBox(listItem.MenuID, 'top')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_zh"
                        :class="`top_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID,'top')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('top',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelected(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="SelectedMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_fr"
                    @click="hideTextBox(listItem.MenuID, 'top')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_fr"
                        :class="`top_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'top')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('top',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelected(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="SelectedMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID, 'top')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel"
                        :class="`top_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'top')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('top',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelected(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>

          <div class="vx-col sm:w-1/3 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="Left Menu" color="primary"></vs-list-header>                
                <vx-tooltip text="Add Custom Menu" position="top">
                  <vs-button radius size="small" color="dark" type="border" icon="add" @click="addCustomPageMenu('left')"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete" @click="removeAll('left')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="SelectedLeftMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLeftMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_de"
                    @click="hideTextBox(listItem.MenuID, 'left')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`left_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'left')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('left',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLeft(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>
              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="SelectedLeftMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLeftMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_fr"
                    @click="hideTextBox(listItem.MenuID, 'left')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`left_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_fr"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'left')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('left',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLeft(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="SelectedLeftMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLeftMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_zh"
                    @click="hideTextBox(listItem.MenuID, 'left')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`left_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_zh"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'left')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('left',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLeft(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="SelectedLeftMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLeftMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID, 'left')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`left_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'left')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        icon="UploadIcon"
                        @click="UploadIcon('left',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLeft(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
        </div>
      </tab-content>

      <tab-content title="App Menu" class="mb-5" icon="feather icon-smartphone">
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full NotificationShow">
            <div class="type-evnt">
              <label>Show App Notification</label>
              <vs-switch v-model="ShowAppNotification" name="ShowAppNotification">
                <span slot="true">True</span>
                <span slot="false">False</span>
              </vs-switch>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-6/12 w-full mt-4">
            <vs-list>
              <div class="vx-col sm:w-1/1 w-full mb-1">
                <div class="menu-head">
                  <vs-list-header title="Available Menus" color="primary"></vs-list-header>
                  <span class="allmenu-topicons">
                    <vs-switch style="width:62px" color="dark" v-model="theme" @change="fetchThemeIcon">
                      <span slot="off">LIGHT</span>
                      <span slot="on">DARK</span>
                    </vs-switch>
                  </span>
                </div>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="AvailableAppMenu"
                :move="checkMoveSelectedApp"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableAppMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_de" />
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="AvailableAppMenu"
                :move="checkMoveSelectedApp"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableAppMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_zh" />
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="AvailableAppMenu"
                :move="checkMoveSelectedApp"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableAppMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel_fr" />
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="AvailableAppMenu"
                :move="checkMoveSelectedApp"
                :group="{name:'tags',pull: 'clone', put: false }"
                :clone="cloneOriginal"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  v-for="(listItem, index) in AvailableAppMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar :src="listItem.IconUrl" slot="avatar" :text="listItem.DisplayLabel" />
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
          <div class="vx-col lg:w-6/12 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="App Bottom Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete" @click="removeAll('bottom')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="SelectedBottomMenu"
                :group="{name: 'tags', put: checkLength('bottom')}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedBottomMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_de"
                    @click="hideTextBox(listItem.MenuID, 'bottom')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_de"
                        :class="`bottom_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'bottom')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('bottom',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedBottom(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="SelectedBottomMenu"
                :group="{name: 'tags', put: checkLength('bottom')}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedBottomMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_zh"
                    @click="hideTextBox(listItem.MenuID, 'bottom')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_zh"
                        :class="`bottom_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'bottom')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('bottom',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedBottom(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="SelectedBottomMenu"
                :group="{name: 'tags', put: checkLength('bottom')}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedBottomMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_fr"
                    @click="hideTextBox(listItem.MenuID, 'bottom')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel_fr"
                        :class="`bottom_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'bottom')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('bottom',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedBottom(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="SelectedBottomMenu"
                :group="{name: 'tags', put: checkLength('bottom')}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedBottomMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID, 'bottom')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.DisplayLabel"
                        :class="`bottom_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'bottom')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('bottom',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedBottom(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>

          <div class="vx-col lg:w-6/12 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="App Hamburger Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete" @click="removeAll('hamburger')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="SelectedHamburgerMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedHamburgerMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_de"
                    @click="hideTextBox(listItem.MenuID, 'hamburger')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`hamburger_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'hamburger')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('hamburger',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedHamburger(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>
              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="SelectedHamburgerMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedHamburgerMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_fr"
                    @click="hideTextBox(listItem.MenuID, 'hamburger')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`hamburger_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_fr"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'hamburger')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('hamburger',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedHamburger(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="SelectedHamburgerMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedHamburgerMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_zh"
                    @click="hideTextBox(listItem.MenuID, 'hamburger')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`hamburger_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_zh"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'hamburger')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('hamburger',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedHamburger(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="SelectedHamburgerMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedHamburgerMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID, 'hamburger')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`hamburger_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'hamburger')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('hamburger',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedHamburger(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
          <div class="vx-col lg:w-6/12 w-full mt-4">
            <vs-list>
              <div class="menu-head">
                <vs-list-header title="App Lobby Menu" color="primary"></vs-list-header>
                <vx-tooltip text="Delete all menus" position="top">
                  <span class="menu-delete" @click="removeAll('lobby')">
                    <feather-icon icon="TrashIcon" />
                  </span>
                </vx-tooltip>
              </div>

              <draggable v-if="defaultEventLanguage == 'de'"
                :list="SelectedLobbyMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLobbyMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_de"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_de"
                    @click="hideTextBox(listItem.MenuID, 'lobby')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`lobby_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_de"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'lobby')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('lobby',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLobby(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>
              <draggable v-else-if="defaultEventLanguage == 'fr'"
                :list="SelectedLobbyMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLobbyMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_fr"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_fr"
                    @click="hideTextBox(listItem.MenuID, 'lobby')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`lobby_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_fr"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'lobby')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('lobby',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLobby(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else-if="defaultEventLanguage == 'zh'"
                :list="SelectedLobbyMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLobbyMenu"
                  :key="index"
                  :title="listItem.DisplayLabel_zh"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel_zh"
                    @click="hideTextBox(listItem.MenuID, 'lobby')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`lobby_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel_zh"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'lobby')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('lobby',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLobby(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

              <draggable v-else
                :list="SelectedLobbyMenu"
                :group="{name: 'tags'}"
                class="p-2 cursor-move menu-dragbox"
              >
                <vs-list-item
                  class="single-list"
                  v-for="(listItem, index) in SelectedLobbyMenu"
                  :key="index"
                  :title="listItem.DisplayLabel"
                >
                  <vs-avatar
                    :src="listItem.IconUrl"
                    slot="avatar"
                    :text="listItem.DisplayLabel"
                    @click="hideTextBox(listItem.MenuID, 'lobby')"
                  />
                  <div class="menu-editwrap">
                    <div class="editbox-menu">
                      <vs-input
                        :placeholder="listItem.Name"
                        :class="`lobby_${listItem.MenuID}`==TextBoxShowingId ? 'show' : 'hidden'"
                        v-model="listItem.DisplayLabel"
                      />
                    </div>
                    <span class="menu-delete" @click="showTextBox(listItem.MenuID, 'lobby')">
                      <img src="../../assets/images/icon-edit.png" />
                    </span>
                    <span class="menu-delete">
                      <feather-icon
                        class="icon"
                        icon="UploadIcon"
                        @click="UploadIcon('lobby',listItem.MenuID)"
                      />
                    </span>
                    <span class="menu-delete" @click="removeSelectedLobby(listItem.MenuID)">
                      <img src="../../assets/images/delete.svg" />
                    </span>
                  </div>
                </vs-list-item>
              </draggable>

            </vs-list>
          </div>
        </div>
      </tab-content>
      <!-- tab  content -->
    </form-wizard>
    <vs-popup class="holamundo customnewpopup" title="Add Custom Page Menu" :active.sync="popupCustomPageMenu">
    <form @submit.prevent="validateForm('form-custompagemenu')" data-vv-scope="form-custompagemenu">
      <div class="vx-row w-630">
          <div class="vx-col md:w-1/2 w-full">
            <vs-radio v-model="MenuType" vs-name="PublicPages" vs-value="PublicPages">Select Public Pages</vs-radio>
            <vs-radio v-model="MenuType" vs-name="CustomUrl" vs-value="CustomUrl" class="ml-3">Enter Custom Url</vs-radio>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label for="">Open In New Tab</label>
            <vs-switch v-model="CustomPageMenu.OpenInNewTab"/>
          </div>            
          <div class="vx-col md:w-1/1 w-full mt-5" v-if="MenuType=='CustomUrl'">
            <label>Page Url <span class="text-danger">*</span></label>
            <vs-input
                    class="w-full"
                    name="PageUrl"
                    v-model="CustomPageMenu.PageUrl"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('form-custompagemenu.PageUrl')"
                    >This field is required</span
                  >
          </div>        
          <div class="vx-col md:w-1/1 w-full mt-5" v-if="MenuType=='PublicPages'">
              <label>Public Page <span class="text-danger">*</span></label>
              <v-select
                class="w-full select-large"
                name="Pageurl"
                v-model="CustomPageMenu.PageUrl"
                label="CdnURL"
                :options="CustomPages" 
                @input="setCustomPageMenuName"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('form-custompagemenu.Pageurl')"
                >This field is required</span
              >
          </div>
          <div class="vx-col md:w-1/1 w-full">
            <label>Menu Name <span class="text-danger">*</span></label>            
            <vs-input
                    class="w-full"
                    name="Name"
                    v-model="CustomPageMenu.Name"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('form-custompagemenu.Name')"
                    >This field is required</span
                  >
          </div>
          <div class="vx-col md:w-1/1 w-full">
            <label>Menu Icon</label>       
            <div class="flex justify-center">  
              <vs-avatar v-if="CustomPageMenu.IconUrl" :src="CustomPageMenu.IconUrl" />              
              <vs-input class="w-full" type="file" @change="uploadCustomMenuIcon" accept="image/*" />              
            </div>
          </div>
          <div class="vx-col md:w-1/1 w-full mt-5 flex justify-center">
              <vs-button
              color="success"
              type="filled"
              class="mr-3"
              @click="before_saveCustomPageMenu()"
          >Save</vs-button>
        </div>
      </div>
    </form>
  </vs-popup>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import modulePageManagement from "@/store/page-management/modulePageManagement.js";
import ls from "@/common/localStorage";

var vm;
export default {
  name: "app",
  data() {
    return {
      ShowNotification: true,
      ShowAppNotification: true,
      MenuType: 'PublicPages',
      CustomPageMenu: {
          "DisplayLabel": "",
          "IconUrl": "",
          "PositionInPage": 4,
          "FeatureName": "",
          "IsPublished": true,
          "MenuID": 0,
          "IsOptional": true,
          "PageUrl": "",
          "GroupID": 0,
          "FeatureID": 0,
          "IsEditable": true,
          "Name": "",
          "DisplayOrder": 4,
          "PositionIsEditable": true,
          "IsPublic": true,
          "OpenInNewTab": true
      },
      popupCustomPageMenu: false,
      CustomPages: [],
      AvailableMenu: [],
      AvailableAppMenu: [],
      SelectedMenu: [],
      SelectedLeftMenu: [],
      SelectedBottomMenu: [],
      SelectedHamburgerMenu: [],
      SelectedLobbyMenu: [],
      TextBoxShowingId: -1,
      updateIconMenuId: 0,
      updateMenuList: null,
      theme:
        ls.getSessionValueByKey("Session_Event_Theme") ==
        "headerColorsHexCodeDark"
          ? true
          : false,
       defaultEventLanguage: null,   
    };
  },
  methods: {
    UploadIcon(menuListName, menuId) {
      this.$refs.changeIcon.click();
      this.updateMenuList = menuListName;
      this.updateIconMenuId = menuId;
    },
    UpdateIcon(input) {
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        let MenuID = this.updateIconMenuId;
        let menuListName = this.updateMenuList;

        this.updateMenuList = null;
        this.updateIconMenuId = 0;

        this.$vs.loading();
        return new Promise((resolve, reject) => {
          this.$store
            .dispatch("eventManagement/updateMenuIcon", { file: file })
            .then((res) => {
              let menulink = res;
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Menu",
                text: "Menu Icon Updated",
              });

              if (menuListName == "top") {
                this.SelectedMenu = this.SelectedMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              } else if (menuListName == "left") {
                this.SelectedLeftMenu = this.SelectedLeftMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              } else if (menuListName == "bottom") {
                this.SelectedBottomMenu = this.SelectedBottomMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              } else if (menuListName == "hamburger") {
                this.SelectedHamburgerMenu = this.SelectedHamburgerMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              } else if (menuListName == "lobby") {
                this.SelectedLobbyMenu = this.SelectedLobbyMenu.map((menu) => {
                  if (menu.MenuID === MenuID) {
                    return { ...menu, IconUrl: menulink };
                  }
                  return { ...menu };
                });
              }

              this.$vs.loading.close();
              resolve(true);
            });
        });
      }
    },
    uploadCustomMenuIcon(input) {
      console.log(input)
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        this.$vs.loading();
          this.$store
            .dispatch("eventManagement/updateMenuIcon", { file: file })
            .then((res) => {
              this.CustomPageMenu.IconUrl = res;
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Menu",
                text: "Menu Icon Updated",
              });            
              this.$vs.loading.close();
            });
      }
    },    
    fetchThemeIcon() {
      if (this.theme) {
        // Dark
        this.AvailableMenu = this.AvailableMenu.map((menu) => {
          return { ...menu, IconUrl: menu.IconUrl.replace("light", "dark") };
        });
        this.AvailableAppMenu = this.AvailableAppMenu.map((menu) => {
          return { ...menu, IconUrl: menu.IconUrl.replace("light", "dark") };
        });
      } // Light
      else {
        this.AvailableMenu = this.AvailableMenu.map((menu) => {
          return { ...menu, IconUrl: menu.IconUrl.replace("dark", "light") };
        });
        this.AvailableAppMenu = this.AvailableAppMenu.map((menu) => {
          return { ...menu, IconUrl: menu.IconUrl.replace("dark", "light") };
        });
      }
    },
    checkMoveSelected: function (evt) {
      //console.log(evt.draggedContext.element.MenuID)
      //console.log(evt.relatedContext.element.MenuID)
      let MenuID = evt.draggedContext.element.MenuID;
      let found = this.SelectedMenu.some((el) => el.MenuID === MenuID);
      let foundl = this.SelectedLeftMenu.some((el) => el.MenuID === MenuID);
      if (found || foundl) return false;
      else return true;
    },
    checkMoveSelectedApp: function (evt) {
      let MenuID = evt.draggedContext.element.MenuID;
      let found = this.SelectedBottomMenu.some((el) => el.MenuID === MenuID);
      let foundl = this.SelectedHamburgerMenu.some((el) => el.MenuID === MenuID);
      //if (found || foundl) return false;
      return true;
    },
    cloneOriginal(menu){
      return {...menu};
    },
    checkLength(field) {
      if (field == "bottom") {
        return !(this.SelectedBottomMenu.length >= 4);
      }else {
        return true
      }
    },
    checkMoveAvailable: function (evt) {
      //console.log(evt.draggedContext.element.MenuID)
      //console.log(evt.relatedContext.element.MenuID)
      let MenuID = evt.draggedContext.element.MenuID;
      let found = this.AvailableMenu.some((el) => el.MenuID === MenuID);
      let found1 = this.AvailableAppMenu.some((el) => el.MenuID === MenuID);
      if (found || foundl) return false;
      else return true;
    },
    showTextBox(id, position) {
      this.TextBoxShowingId = `${position}_${id}`;
    },
    hideTextBox(id) {
      this.TextBoxShowingId = -1;
    },
    removeAll(menuListName) {
      if (
        confirm(
          "Are you sure want to clear all " +
            menuListName.toUpperCase() +
            " menu"
        )
      ) {
        if (menuListName == "top") {
          this.SelectedMenu = [];
        } else if (menuListName == "left") {
          this.SelectedLeftMenu = [];
        } else if (menuListName == "bottom") {
          this.SelectedBottomMenu = [];
        } else if (menuListName == "hamburger") {
          this.SelectedHamburgerMenu = [];
        } else if (menuListName == "lobby") {
          this.SelectedLobbyMenu = [];
        }
      }
    },
    removeSelected(id) {
      var index = this.SelectedMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedMenu.splice(index, 1);
    },
    removeSelectedLeft(id) {
      var index = this.SelectedLeftMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedLeftMenu.splice(index, 1);
    },
    removeSelectedBottom(id) {
      var index = this.SelectedBottomMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedBottomMenu.splice(index, 1);
    },
    removeSelectedHamburger(id) {
      var index = this.SelectedHamburgerMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedHamburgerMenu.splice(index, 1);
    },
    removeSelectedLobby(id) {
      var index = this.SelectedLobbyMenu.map((x) => {
        return x.MenuID;
      }).indexOf(id);

      this.SelectedLobbyMenu.splice(index, 1);
    },
    before_save() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          resolve(result);
          if (result) vm.formSubmitted();
        });
      });
    },
    formSubmitted() {
      //console.log(this.EventData)
      //alert("Form submitted!");
      this.$vs.loading();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let SelectedMenu = this.SelectedMenu.map((item, index) =>{
        item.DisplayOrder = index
        return item
      })
      let SelectedLeftMenu = this.SelectedLeftMenu.map((item, index) =>{
        item.DisplayOrder = index
        return item
      }) 
           
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("eventManagement/updateEventMenu", {
            id: Session_Event_Id,
            SelectedMenu: SelectedMenu,
            SelectedLeftMenu: SelectedLeftMenu,
            ShowNotification: this.ShowNotification,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Event",
              text: res.message,
            });

            this.$vs.loading.close();
            resolve(true);
            this.updateAppMenu();
          });
      });
    },
    updateAppMenu(){
      this.$vs.loading();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      let SelectedBottomMenu = this.SelectedBottomMenu.map((item, index) =>{
        item.DisplayOrder = index
        return item
      }) 
      let SelectedHamburgerMenu = this.SelectedHamburgerMenu.map((item, index) =>{
        item.DisplayOrder = index
        return item
      }) 
      let SelectedLobbyMenu = this.SelectedLobbyMenu.map((item, index) =>{
        item.DisplayOrder = index
        return item
      }) 
      this.$store.dispatch("eventManagement/updateEventAppMenu", {
        id: Session_Event_Id,            
        SelectedBottomMenu: SelectedBottomMenu,
        SelectedHamburgerMenu: SelectedHamburgerMenu,
        SelectedLobbyMenu: SelectedLobbyMenu,
        ShowAppNotification: this.ShowAppNotification
      }).then((res) => {
        this.$vs.loading.close();
        this.$vs.notify({
          color: "success",
          position: "top-center",
          title: "Event",
          text: res.message,
        });
      })
    },
    fetchEventAppMenu(){
      this.$store.dispatch("eventManagement/fetchEventAppMenu").then((res) => {
        //console.log(res)
          this.ShowAppNotification = res.ShowAppNotification == undefined ? true : res.ShowAppNotification;
          this.SelectedBottomMenu = res.SelectedBottomMenu ? res.SelectedBottomMenu : [];
          this.SelectedHamburgerMenu = res.SelectedHamburgerMenu ? res.SelectedHamburgerMenu : [];
          this.SelectedLobbyMenu = res.SelectedLobbyMenu ? res.SelectedLobbyMenu : [];
        });
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEventMenu", Session_Event_Id)
        .then((res) => {
          this.AvailableMenu = res.AvailableMenu ? res.AvailableMenu : [];
          this.AvailableAppMenu = res.AvailableMenu ? res.AvailableMenu : [];
          this.SelectedMenu = res.SelectedMenu ? res.SelectedMenu : [];
          this.SelectedLeftMenu = res.SelectedLeftMenu
            ? res.SelectedLeftMenu
            : [];
          this.ShowNotification = res.ShowNotification == undefined ? true : res.ShowNotification;          
          this.fetchThemeIcon();
          this.fetchEventAppMenu();
        })
        .catch((err) => {});        
    },
    fetch_customPages(){
      this.$store.dispatch("pageManagement/fetchPages").then((res) => {
        this.CustomPages = res.map(item=>{ 
          if(item.IsPublished){
            return {
              CdnURL: item.CdnURL,
              PageId: item.PageId,
              Slug: item.Slug,
              Title: item.Title
            }
          }
        });
      });
    },
    addCustomPageMenu(pos){
      this.CustomPageMenu.menuPos = pos;
      this.popupCustomPageMenu = true;
    },
    before_saveCustomPageMenu(){
      this.$validator.validateAll("form-custompagemenu").then((result) => {
          if (result) {
            this.saveCustomPageMenu();
          }
       });
    },
    async saveCustomPageMenu(){
      if(this.MenuType == 'CustomUrl'){
        let menuId = await this.$store.dispatch('eventManagement/generateNumber', 6);
        this.CustomPageMenu.MenuID = `CUST${menuId}`;
      }
      this.CustomPageMenu.DisplayLabel = this.CustomPageMenu.Name;
      let menuPos = this.CustomPageMenu.menuPos;
      delete this.CustomPageMenu.menuPos;
      if(menuPos == 'top'){
        this.SelectedMenu.push(this.CustomPageMenu);
      }
      else if(menuPos == 'left'){
        this.SelectedLeftMenu.push(this.CustomPageMenu);
      }
      this.popupCustomPageMenu = false;
    },
    setCustomPageMenuName(){
      if(this.CustomPageMenu.PageUrl){    
        let selectedPage = this.CustomPageMenu.PageUrl;
        this.CustomPageMenu.PageUrl = selectedPage.CdnURL;
        this.CustomPageMenu.Name = selectedPage.Title;
        this.CustomPageMenu.MenuID = selectedPage.PageId;
      }
    }
  },
  components: {
    FormWizard,
    TabContent,
    draggable,
    vSelect
  },
  mounted() {    
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!modulePageManagement.isRegistered) {
      this.$store.registerModule("pageManagement", modulePageManagement);
      modulePageManagement.isRegistered = true;
    }
    this.fetch_event_data();
    this.fetch_customPages();
    vm = this;
    var language = ls.getSessionValueByKey("Default_Event_Language");
    if(language == "English"){
       this.defaultEventLanguage = "eng";
    }else if(language == "Mandarin"){
      this.defaultEventLanguage = "zh";
    }else if(language == "French"){
      this.defaultEventLanguage = "fr";
    }else if(language == "German"){
      this.defaultEventLanguage = "de";
    }
    
  },
  watch: {
    MenuType(val){
      this.CustomPageMenu.PageUrl = '';
      this.CustomPageMenu.Name = '';
      this.CustomPageMenu.MenuID = '';
    },
    theme(val) {
      //alert("theme" + val);
      //debugger;
      vm.SelectedMenu.forEach(function (menu) {
        //menu.
        if (val) {
          menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
          menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
        } else {
          menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
          menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
        }
      });
      vm.SelectedMenu = vm.SelectedMenu.filter(function (value) {
        return value.DisplayLabel != "";
      });
      vm.SelectedLeftMenu.forEach(function (menu) {
        //menu.
        if (val) {
          menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
          menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
        } else {
          menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
          menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
        }
      });
      vm.SelectedLeftMenu = vm.SelectedLeftMenu.filter(function (value) {
        return value.DisplayLabel != "";
      });
      vm.SelectedBottomMenu.forEach(function (menu) {
        //menu.
        if (val) {
          menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
          menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
        } else {
          menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
          menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
        }
      });
      vm.SelectedBottomMenu = vm.SelectedBottomMenu.filter(function (value) {
        return value.DisplayLabel != "";
      });
      vm.SelectedHamburgerMenu.forEach(function (menu) {
        //menu.
        if (val) {
          menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
          menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
        } else {
          menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
          menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
        }
      });
      vm.SelectedHamburgerMenu = vm.SelectedHamburgerMenu.filter(function (value) {
        return value.DisplayLabel != "";
      });
      vm.SelectedLobbyMenu.forEach(function (menu) {
        //menu.
        if (val) {
          menu.IconUrl = menu.IconUrl.replace("/light/", "/dark/");
          menu.IconUrl = menu.IconUrl.replace("%2Flight%2F", "%2Fdark%2F");
        } else {
          menu.IconUrl = menu.IconUrl.replace("/dark/", "/light/");
          menu.IconUrl = menu.IconUrl.replace("%2Fdark%2F", "%2Flight%2F");
        }
      });
      vm.SelectedLobbyMenu = vm.SelectedLobbyMenu.filter(function (value) {
        return value.DisplayLabel != "";
      });
    },
  },
};
</script>